import {
  Skeleton,
  Panel,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { GreyGrey30 } from '@sequencehq/core-components'

export const ScheduleLoadingSkeleton = () => {
  return (
    // Wrapped in a Panel so the loading state matches the floating white panel
    // of the loaded layout — avoids a flash of unstyled gray on navigation.
    <Panel width="100%" height="100%">
      <Grid
        data-testid="cube.loadingLayout"
        templateAreas={`
  "header header"
  "content inspector"
  `}
        templateRows={`48px 1fr`}
        templateColumns={`1fr 48px`}
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <GridItem
          gridArea="header"
          borderBottom={`1px solid ${GreyGrey30}`}
          display="flex"
          alignItems="center"
          paddingLeft="16px"
        >
          <Skeleton height="24px" width="220px" />
        </GridItem>
        <GridItem
          gridArea="inspector"
          borderLeft={`1px solid ${GreyGrey30}`}
          display="flex"
          flexDirection="column"
          alignItems="center"
          padding="8px"
          gap="2px"
        >
          <Skeleton height="32px" width="32px" />
          <Skeleton height="32px" width="32px" />
          <Skeleton height="32px" width="32px" />
        </GridItem>
        <GridItem
          gridArea="content"
          display="flex"
          alignItems="center"
          flexDirection="column"
          padding="24px"
        >
          <Flex
            flexDirection="column"
            alignContent="flex-start"
            width="1168px"
            gap="16px"
          >
            <Skeleton height="214px" width="100%" />
            <Skeleton height="448px" width="100%" />
            <Skeleton height="260px" width="100%" />
          </Flex>
        </GridItem>
      </Grid>
    </Panel>
  )
}
